module.exports = __webpack_public_path__ + "img/workNewsCover3.5427b5a0.png";